<template>
<div class="product-template">
	<div class="product-template-image"> 
		<product-slider :images="props.productDetail.image_url.split(',')"/>
	</div>
	<div class="product-template-info"> 
		<div class="p-2 w-100">
		<h3 class="mb-2">{{props.productDetail.stuff_name}}</h3>
		<div v-html="props.productDetail.main_description" style="text-align: justify;font-size: 15px;" v-if="props.productDetail.main_description"></div>
		<div v-html="props.productDetail.description" class="text-muted" style="text-align: justify;font-size: 15px;" v-else></div>
		<p v-if="props.productDetail.discount > 0" class="mb-0"> 
			<span class="item_price pt-2">
				<div class="d-flex align-items-center">
					<del class="d-block">{{convertToPersian(props.productDetail.price)}}</del>
					<label class="text-danger mr-1 product-discount" :class="{'peculiar-discount' : props.productDetail.discount > 4}">%{{convertToPersian(props.productDetail.discount)}}</label> 
				</div> 
				<strong>
					{{convertToPersian(numberFormat((parseInt(props.productDetail.price.replaceAll(',','') ) - (parseInt(props.productDetail.price.replaceAll(',','')) * (parseInt(props.productDetail.discount) / 100)))))}} 
				</strong>
			</span> 
			تومان 
		</p>
		<p v-else class="mb-0 pt-2"> 
			<strong class="item_price">{{convertToPersian(props.productDetail.price)}}</strong> تومان 
		</p>
	</div>
		<div style="position: relative !important;width:11em" v-if="props.productDetail.close != 1">
			<button-template :id="props.productDetail.id" :sid="props.productDetail.store_place_id" :flag="`single`" :quantity="props.productDetail.quantity" origin="product"/>
		</div>
		<div v-else>
			<button class="btn btn-secondary" disabled>فروشگاه بسته است</button>
			<br />
			<small class="d-block mt-3">فروشگاه در حال حاضر بسته است، لطفا لحظاتی بعد تلاش کنید</small>
		</div>
	</div>
</div>
</template>

<script setup>
import ButtonTemplate from '../../item/button.vue';
import ProductSlider from '../../item/productSlider.vue';
import defineProps from 'vue'
import { convertToPersian, numberFormat } from '@/composables/digits';

let props = defineProps(['productDetail'])



</script>

<style scoped>

h3,h6,p{
	font-family: IranSans;
}
.fl-right{
	float:right;
}
.hZkLjq{
	    position: inherit !important;
		display: block;
}
.occasion-cart{
	position: relative !important;
	margin-bottom: 60px;
    height: 0px;

}
.product-template-info{
	display: flex;
	justify-content: space-between;
	align-items: start !important;
	flex-direction: column !important;
}
img{
	border-radius: .5em;
	width: 425px;
}
.product-template-image{

	text-align: center
}
.product-discount{
    border: 1px solid red;
    line-height: 1.1;
    font-size: 12px;
    font-weight: 700;
    border-radius: 4px;
	background: red !important;
	color: white !important;
	font-family: 'IranSans';
}

</style>
<style>
@media (max-width:600px) {
	.h_iframe-aparat_embed_frame{
		width: 100% !important;
		height: 100% !important;
		margin-right: auto !important;
		margin-left:auto !important;
	}
}
@media (min-width:601px) {
	.h_iframe-aparat_embed_frame{
		width: 60% !important;
		height: 60% !important;
		margin-right: auto !important;
		margin-left:auto !important;
	}
}
.text-dark-s{
    color:#212529;
}
.text-primary-s{
    color: #0d6efd;
}
.text-success-s{
    color:#198754;
}
.text-warning-s{
    color:#ffc107;
}
.text-danger-s{
    color:#dc3545;
}
.text-info-s{
    color:#0dcaf0;
}
.text-secondary-s{
    color:#6c757d;
}
.text-link-s{
    color:#0d6efd;
}	
.text-muted-s{
    color:#6c757d;
}
p{
	margin-bottom: 0 !important; 
}
</style>